import { render } from "./HotspotDetail.vue?vue&type=template&id=38ba4b00"
import script from "./HotspotDetail.vue?vue&type=script&lang=js"
export * from "./HotspotDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__